<template>
  <div class="users-list">
    <el-table
        :data="users"
        style="width: 100%;"
        @filter-change="filterChange">
      <el-table-column  prop="name">
        <template slot="header" slot-scope="scope">
          <header-sort-title
              @sort="sort"
              title="Name"
              :status-sort="sortBy"
              sort-key="last_name"
          />
        </template>
        <template slot-scope="scope">
          {{ scope.row.first_name }} {{ scope.row.last_name }}
        </template>
      </el-table-column>

      <el-table-column  prop="name">
        <template slot="header" slot-scope="scope">
          <header-sort-title
              @sort="sort"
              title="E-mail"
              :status-sort="sortBy"
              sort-key="email"
          />
        </template>
        <template slot-scope="scope">
          {{ scope.row.email }}
        </template>
      </el-table-column>

      <el-table-column  prop="payment_service_id">
        <template slot="header" slot-scope="scope">
          Stripe ID
        </template>
        <template slot-scope="scope">
          {{ scope.row.payment_service_id }}
        </template>
      </el-table-column>

      <el-table-column  prop="created_at">
        <template slot="header" slot-scope="scope">
          <header-sort-title
              @sort="sort"
              title="Created At"
              :status-sort="sortBy"
              sort-key="created_at"
          />
        </template>
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column  prop="status_id"
                       column-key="status"
                       :filters="filtersOptions">
        <template slot="header" slot-scope="scope">
          <span> User status</span>
        </template>
        <template slot-scope="scope">
          <status-user-changing
              :user-index="scope.row.id"
              :user-data="scope.row"
              :format-data="formatData"
          />
        </template>
      </el-table-column>

      <el-table-column
          prop="roles"
          column-key="roles"
          :filters="[
            {text: 'Administrator', value: 'administrator' },
            {text: 'Manager', value: 'manager' },
            {text: 'User', value: 'user'},
            {text: 'Seo', value: 'seo'},
          ]"
      >
        <template slot="header" slot-scope="scope">
          Role
        </template>
        <template slot-scope="scope">
          {{ scope.row.roles.map(c => c.name).join(', ') }}
        </template>
      </el-table-column>

      <el-table-column  align="center">
        <template slot="header" slot-scope="scope">
          <span>Actions</span>
        </template>
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
          >Edit
          </el-button>
          <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
          >Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagin-wrp">
      <el-pagination
          :current-page="chosenPageFromVuex"
          :background="true"
          layout="prev, pager, next"
          :page-size="1"
          @current-change="chosePage"
          :total="usersMeta.last_page"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>

  import HeaderSortTitle from '../UsersList/HeaderSortTitle'
  import { mapGetters, mapActions } from 'vuex';
  import StatusUserChanging from '../UsersList/StatusUserChanging'

  export default {
    name: "UserTableList",
    components: {
      HeaderSortTitle,
      StatusUserChanging,
    },
    props: {
      pageLabel: String,
      filterProps: {},
      countUser: Number,
      filterUser: String,
    },
    data () {
      return {
        filterUsers: '',
        sortBy: {
          last_name: 0,
          email: 0,
          created_at: 0,
        },
        filtersOptions: [
          { text: 'Active', value: 1 },
          { text: 'Inactive', value: 2 },
          { text: 'Blocked', value: 3 },
        ],
        filterBlock:this.filterProps,
      }
    },
    computed: {
      ...mapGetters({
        users: 'users/users',
        usersMeta: 'users/usersMeta',
        searchParams: 'users/searchParams',
        formatData: 'formatData/getFormates',
        selectedFilter: 'usersPageFilter/getSelectedFilter',
        chosenPageFromVuex: 'usersPageFilter/getChosenPage',
      }),
      chosenPage: {
          get() {
              return this.chosenPageFromVuex;
          },
          set(value) {
              this.$store.dispatch('usersPageFilter/updateChosenPage', value);
          },
      },       
    },
 
    created () {
      this.$store.dispatch('users/getUsers')
      if(!this.getFormates){
        this.$store.dispatch('formatData/getFormatData')
      }
      this.updateUserList();
      this.loadData();
    },

    watch:{
      getSelectedFilter: {
        immediate: true,
        handler(value) {
          if (value) {
            this.handleFilterChange(value);
          }
        },
      },   
      filterUser(){
        this.chosenPage = 1
        this.updateUserList()
      }           
    },
    methods: {
      ...mapActions({
        'updateSelectedFilter': 'usersPageFilter/updateSelectedFilter',
        'updateFilterBlock': 'usersPageFilter/updateFilterBlock'
      }),
      ...mapGetters('filterBlock', ['getFilterBlock']),      

      loadData() {
        this.filterBlock = this.getFilterBlock;
        this.updateUserList();
      },      
      handleFilterChange(filter) {
        this.updateSelectedFilter(filter);
      },      
      filterChange(filter) {
        this.filterBlock = filter
        this.$emit('updateContent',  this.filterBlock)
        this.handleFilterChange(filter);
        this.updateUserList()
      },
      chosePage (e) {
        this.chosenPage = e
        this.updateUserList()
      },
      sort(by) {
        let key  = (typeof by ==="object") ? by.prop : by
        console.log(by)
        if (this.sortBy[key] === 0) {
          this.sortBy[key] = 1
        } else if (this.sortBy[key] === 1) {
          this.sortBy[key] = -1
        } else if (this.sortBy[key] === -1) {
          this.sortBy[key] = 0
        }
        if(typeof by ==="object" && by.order==null){
          this.sortBy[key] = 0
        }
        this.updateUserList()
      },
      updateUserList () {
        let params = 'sort='
        if (this.sortBy) {
          for (let itm in this.sortBy) {
            if (this.sortBy[itm] === 1) {
              params = `${params}${itm},`
            } else if (this.sortBy[itm] === -1) {
              params = `${params}-${itm},`
            }
          }
        }

        if (params === 'sort=') {
          params = ''
        }

        params = `${params}&page=${this.chosenPage}`

        if (this.countUser) {
          params = `${params}&per_page=${this.countUser}`
        }

        if (this.filterUser.length) {
          params = `${params}&filter=${encodeURIComponent(this.filterUser)}`
        }

        if (this.selectedFilter) {
          this.filterBlock = this.selectedFilter; 
          this.handleFilterChange(this.filterBlock);
        } 

        if (typeof this.filterBlock != 'undefined' && Object.keys(this.filterBlock).length) {
          Object.entries(this.filterBlock).forEach(([key, value]) => {
            if(value.length==0){
              return;
            }
            if(key === 'roles') {
              value.forEach(el => {
                params = `${params}&${key}[]=`+el
              })
            } else {
              params = `${params}&${key}=`+JSON.stringify(value)
            }
          });
        }
        this.$store.dispatch('users/getUsers', params)

       
      },
      handleEdit (index, row) {
        this.$router.push({name: 'user-edit', params: {id: row.id}})
      },
      handleDelete (index, row) {
        this.$confirm('This will trash the user. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
          center: true
        }).then(() => {
          this.$store.dispatch('users/deleteUser', row.id)
          this.$message({
            type: 'success',
            showClose: true,
            message: 'Delete completed'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            showClose: true,
            message: 'Delete canceled'
          });
        });
      },
    }

  }
</script>

